import * as React from 'react';

const SvgWaterGlass = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={54} height={54} fill="none" {...props}>
    <path
      clipRule="evenodd"
      d="M27 18.563c10.252 0 18.563-3.778 18.563-8.438S37.252 1.687 27 1.687c-10.252 0-18.563 3.778-18.563 8.438S16.748 18.563 27 18.563z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.438 10.125l6.383 35.1a6.491 6.491 0 002.335 3.992A15.656 15.656 0 0027 52.313a15.656 15.656 0 009.844-3.09 6.492 6.492 0 002.335-3.998l6.383-35.1"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.938 51.624V37.125a5.063 5.063 0 0110.125 0v14.499M12.555 32.77c3.27-3.43 9.383 2.5 9.383 4.354M41.445 32.77c-3.27-3.43-9.383 2.5-9.383 4.354"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgWaterGlass;
